module.exports = "/images/regel-3.jpg?a9eaee57708307b251c457e013bfb6e8";